import { useState } from "react";
import "../../styles/studio/visualization/theoryInput.css";

const TAGS = [
  { key: "primary-text", label: "Primary" },
  { key: "secondary-text", label: "Secondary" },
  { key: "third-text", label: "Third" },
  { key: "sub-topic", label: "Sub Topic" },
];

const TheoryInput = ({ theory, setTheory, isLoading }) => {
  const [activeTag, setActiveTag] = useState("primary-text");

  const openTag = `{{${activeTag}}}`;
  const closeTag = `{{/${activeTag}}}`;

  const handleChange = (e) => {
    setTheory(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && e.ctrlKey) {
      e.preventDefault();

      setTheory((prev) => {
        return prev + closeTag + openTag;
      });
    }
  };

  const insertTagBlock = (tag) => {
    setActiveTag(tag);
    setTheory((prev) => prev + `{{${tag}}}`);
  };

  return (
    <div className="theory-input">
      <label className="theory-label">
        Theory <span className="required">*</span>
      </label>

      <div className="theory-toolbar">
        {TAGS.map((tag) => (
          <button
            key={tag.key}
            type="button"
            className={`theory-tag-btn ${
              activeTag === tag.key ? "active" : ""
            }`}
            onClick={() => insertTagBlock(tag.key)}
            disabled={isLoading}
          >
            {tag.label}
          </button>
        ))}
      </div>

      <textarea
        className="theory-field"
        placeholder="Start writing theory..."
        value={theory}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        rows={10}
        disabled={isLoading}
      />

      <div className="theory-hint">
        Enter creates a new block of the same type. Formatting is handled
        automatically.
      </div>
    </div>
  );
};

export default TheoryInput;
